// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2GlyR","selected":"Chip_selected__20TRd"};